<template>
 <div class="dankal-image-upload">
    <p v-for="(item,index) in list" :key="index">
		<img class="upload_img" :src="imgDomain + item" alt="">
		<img class="close" src="@/assets/images/order-manage/ic_delete.png" @click="onDeleted(index)">
    </p>
	
    <div
      class="add-box"
      v-if="list.length < limit">
      <img
        @click='onSelected'
        class="add"
        src="@/assets/images/home/ic_home_add.png"
        alt=""
      >
      <!-- <span v-if="type == 1">上传图片({{ list.length }}/{{ limit }})</span> -->
      <!-- <span v-if="type == 2">尺寸：695*418像素，图片格式JPG,png</span> -->
    </div>
    <input
      multiple="multiple"
      ref="input"
      type="file"
      id="file"
      accept="image/*"
      style="display:none;"
      @change="onFileChanged"
    >
  </div>
</template>

<script>
import ImageCompressor from 'image-compressor.js';
import { uploadImg, getCommunal } from '@/api/common';

export default {
    name: 'DankalImageUpload',

    data() {
        return {
            list: [],
            toast: '',
            imgDomain: "https://cdn.yongxintao.com/"
        };
    },

    created() {
        this.toast = this.$createToast({
            txt: '上传中...',
            mask: true,
        });
    },

    props: {
        value: {
            type: Array,
            required: true,
        },
        
        limit: {
            type: Number,
            default: 3,
        },
        
        quatity: {
            type: Number,
            default: 0.6,
        },
        
        // 1是帖子上传图片，2是上传封面图，3是上传反馈
        type: {
            type: Number,
            default: 1,
        },
    },

    watch: {
        value(n) {
        this.list = n;
        },
    },

    mounted() {
        this.list = this.value;
        console.log(this.list, '图片列表')
    },

    methods: {
        onSelected() {
            const { limit, list } = this;
            if (limit && list.length >= limit) {
                this.$createToast({ txt: `只能上传${limit}张图片`, time: 1500 }).show();
                this.toast.show();
                return;
            }

            this.$refs.input.click();
        },

        onDeleted(index) {
          // Array.prototype.splice(this.list, index, 1);
            this.list.splice(index, 1)
            this.$emit('input', this.list);
        },

        onFileChanged(event) {
            // const file = event.target.files[0];
            var fileList = event.target.files;
            var file;
            
            for(var i=0;i<fileList.length;i++){
                file = fileList[i];
                
                if (!file) return;
                
                // eslint-disable-next-line
                new ImageCompressor(file,{
                    quatity: this.quatity,
                    // eslint-disable-next-line
                    success: result => {
                        this.upload(result);
                    },
                    // eslint-disable-next-line
                    error: error => {
                        this.$createToast({ txt: error.message, time: 1500 }).show();
                    },
                });
                
                this.toast.show();
            }
        },

        async upload(file) {
            //首先获取七牛信息
            const { data, status } = await getCommunal();
            if (status !== 200) return 
            this.imgDomain = data.BucketDomain;
            // await this.$store.dispatch('getUrlAndTokenOfImageUpload')
            const formData = new FormData();
            formData.append('token', data.token)
            formData.append('file', file);
            const res = await uploadImg(formData).catch(() => {});
            this.toast.hide();
            if (res.status === 200) {
                this.list.push(res.data.hash);
                if(this.list.length>this.limit){
                    window.toast("最多只能上传"+this.limit+"张图片");
                    this.list = this.list.slice(0,this.limit)
                }
                console.log(this.list, '图片列表更新')
                this.$emit('input', this.list);
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variable.less';
@import '~@/assets/styles/handleMethods.less';

.dankal-image-upload{
  display: flex;
  flex-wrap: wrap;
  p {
    position: relative;
    .w(95);
    .h(95);
    margin: 0 0 .46rem .5rem;
    .m-r(10);
    float: left;
    .upload_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .close {
    	.w(20);
    	.h(20);
      position: absolute;
      top: -0.13rem;
      right: -0.13rem;
    }
  }
	
	p:nth-child(3n){.m-r(0);}
  .add-box{
    display: flex;
    flex-direction: column;
    padding-left: .5rem;
	padding-bottom: 17px;
    .add {
    	.w(95);
    	.h(95);
    }
    span{
      color: #CFCFCF;
      font-size: .22rem;
    }
  }
}
</style>
